/* eslint-disable no-bitwise */
export function formatDuration(time: number) {
  const hrs = ~~(time / 3600);
  const mins = ~~((time % 3600) / 60);
  const secs = ~~time % 60;

  let ret = '';
  if (hrs > 0) ret += `${hrs < 10 ? '0' : ''}${hrs}:`;
  ret += `${String(mins).padStart(2, '0')}:${secs < 10 ? '0' : ''}`;
  ret += `${secs}`;
  return ret;
}
